import { useQuery } from '@tanstack/react-query';
import { HAS_ACTIVE_US_CASE_KEY } from '../../utils/constants/queryKeys';
import { checkHasActiveUsCase } from '../services/ims-api/Beneficiary';

export const useCheckHasActiveUsCase = (beneId: number | undefined) => {
  return useQuery({
    queryKey: [HAS_ACTIVE_US_CASE_KEY, beneId],
    queryFn: () => checkHasActiveUsCase(beneId!),
    enabled: !!beneId,
  });
};
